import { CloseIcon, SearchIcon } from "./Icons";

type SearchBoxProps = {
  value: string;
  onChange: (value: string) => void;
};

export function SearchBox({ value, onChange }: SearchBoxProps) {
  return (
    <div className="search-box">
      <SearchIcon className="search-box__icon" />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search resource titles or summaries..."
        aria-label="Search resource titles or summaries"
      />
      {value ? (
        <button className="search-box__clear" type="button" onClick={() => onChange("")} aria-label="Clear search">
          <CloseIcon />
        </button>
      ) : null}
    </div>
  );
}
